/* eslint-disable indent */
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FinProposta } from '../../../models/fin-proposta';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CarregandoService } from '../../../services/carregando.service';
import { NotificacaoService } from '../../../services/notificacao.service';
import { FinSimulacaoService } from '../../../services/fin-simulacao.service';
import { FinSimulacaoFinanciadora } from '../../../models/fin-simulacao-financiadora';
import {
  AnaliseDescontoStatus,
  FinPropostaStatus,
  FinPropostaTipoCriacao,
  FinSimulacaoFinanciadoraStatus,
  FinSimulacaoOrigem,
  FinSimulacaoStatus,
  StatusTarefa,
  TipoArquivo,
  TipoCampoPersonalizado,
  TipoFormularioProposta
} from '../../../models/enum';
import { MatDialog, MatDialogRef } from '@angular/material';
import { CadastrarFinPropostaComponent } from '../../modals/cadastrar-fin-proposta/cadastrar-fin-proposta.component';
import { FinSimulacao } from '../../../models/fin-simulacao';
import { FilaTarefa } from '../../../models/filas/fila-tarefa';
import { GlobalService } from '../../../services/global.service';
import { ArquivoService } from '../../../services/arquivo.service';
import { UtilitarioService } from '../../../services/utilitario.service';
import { FinanciamentoService } from '../../../services/financiamento.services';
import { Financiamento } from '../../../models/financiamento/financiamento';
import swal from 'sweetalert2';
import { CommonFinanceModel } from '../../models/common-finance-model';
import { GiFinPropostaModel } from 'src/app/dominio/gi-fin-proposta-model';
import { QueryFilterService } from 'src/app/core/services/query-filter-service';
import { GridfyFilter } from 'src/app/core/models/gridfy-filter';
import { FinanciadorasComponent } from '../financiadoras/financiadoras.component';
import { GiFinSimulacaoModel } from '../../../dominio/gi-fin-simulacao-model';
import { SumarioFormularioFinanciadoraModel } from '../../models/sumario-formulario-financiadora';
import { PerguntaFormularioModel } from 'src/app/dominio/pergunta-formulario-model';
import { FormularioGatewayModel } from 'src/app/dominio/formulario-gateway-model';
import { RespostaFormularioModel } from 'src/app/dominio/resposta-formulario-model';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { FormlyJsonschema } from '@ngx-formly/core/json-schema';

@Component({
  selector: 'app-fin-propostas',
  templateUrl: './fin-propostas.component.html',
  styleUrls: ['./fin-propostas.component.scss']
})
export class FinPropostasComponent implements OnInit {
  @Input() simulacao: GiFinSimulacaoModel;

  @Input() origem: FinSimulacaoOrigem;

  @Input() tarefa: FilaTarefa;

  // @Input() dialogRef: MatDialogRef<FinSimulacaoSolicitacaoModalComponent>;

  FinSimulacaoOrigem = FinSimulacaoOrigem;

  propostas: GiFinPropostaModel[] = [];

  public config: PerfectScrollbarConfigInterface = {};

  FinSimulacaoFinanciadoraStatus = FinSimulacaoFinanciadoraStatus;

  podeInserirProposta = false;

  integrador = false;

  FinSimulacaoStatus = FinSimulacaoStatus;

  FinPropostaStatus = FinPropostaStatus;

  configFinanciamento: Financiamento;

  FinPropostaTipoCriacao = FinPropostaTipoCriacao;

  suporte = false;

  commom: CommonFinanceModel = new CommonFinanceModel();

  editavel = false;

  sumarioFormularioFinanciadora = new SumarioFormularioFinanciadoraModel();
  formularioManual: PerguntaFormularioModel[] = [];
  formularioGateway = new FormularioGatewayModel();

  formlyConfigForm: FormGroup = new FormGroup({});
  formlyOptions: FormlyFormOptions;
  formlyFields: FormlyFieldConfig[];
  formlyModel = {};

  @ViewChild(FinanciadorasComponent, { static: false }) financiadorasComponent: FinanciadorasComponent;

  constructor(
    private carregandoService: CarregandoService,
    private finSimulacaoService: FinSimulacaoService,
    private notificacaoService: NotificacaoService,
    public dialog: MatDialog,
    private globalService: GlobalService,
    private arquivoService: ArquivoService,
    private utilitarioService: UtilitarioService,
    private financiamentoService: FinanciamentoService,
    private queryFilterService: QueryFilterService,
    private formlyJsonschema: FormlyJsonschema
  ) {}

  async ngOnInit() {
    this.suporte = await this.globalService.suporte();

    this.integrador = await this.globalService.integrador();

    if (this.tarefa !== null && this.tarefa !== undefined) {
      switch (this.tarefa.status) {
        case StatusTarefa.Iniciada:
        case StatusTarefa.Retomada:
          this.podeInserirProposta = true;
          this.editavel = true;
          break;

        default:
          this.podeInserirProposta = false;
          this.editavel = false;
          break;
      }
    }

    // await this.buscarPropostas();
    this.buscarFinanciamentoConfig();
  }

  async buscarPropostas() {
    this.carregandoService.mostra('buscarPropostas');

    const queryFilter = this.queryFilterService.getQueryBuilder();
    this.queryFilterService.applyFilters(queryFilter, this.definirFiltros());

    this.finSimulacaoService.buscarPropostasV2Tarefa(this.tarefa.id, queryFilter.build()).subscribe(
      (data) => {
        this.propostas = data.results;

        this.propostas.forEach((p) => this.buscarSumarioProposta(p));

        this.carregandoService.esconde('buscarPropostas');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPropostas');
        this.notificacaoService.erro(erro);
      }
    );
  }

  definirFiltros(): GridfyFilter[] {
    let filtros: GridfyFilter[] = [];

    if (this.commom != null && this.commom.idVinculo != null) {
      filtros.push({ field: 'idVinculo', operator: '=', value: this.commom.idVinculo.toString() });
    }

    return filtros;
  }

  buscarImagem(financiadora: FinSimulacaoFinanciadora) {
    try {
      financiadora.imagem$ = this.arquivoService
        .baixarArquivo(financiadora.idFinanciadora, TipoArquivo.FinanciadoraImagem)
        .map((m) => this.utilitarioService.toBase64ComInicio(m))
        .toPromise();
      financiadora.imagem$
        .then((p) => {
          financiadora.buscouImagem = true;
        })
        .catch((p) => {
          financiadora.semImagem = true;
        });
    } catch (erro) {
      this.notificacaoService.erro(erro);
    }
  }

  novaProposta() {
    const dialogRef = this.dialog.open(CadastrarFinPropostaComponent, {
      width: '1078px',
      data: {
        simulacao: this.simulacao,
        idTarefa: this.tarefa.id
      },
      panelClass: ['modal-card', 'modal-card-v2']
    });

    dialogRef.afterClosed().subscribe(async (result: any) => {
      if (result) {
        await this.financiadorasComponent.atualizarFinanciadoras();
      }
    });
  }

  editarProposta(proposta: GiFinPropostaModel, idFinanciadora) {
    const copia = Object.assign({}, proposta);

    const dialogRef = this.dialog.open(CadastrarFinPropostaComponent, {
      width: '1078px',
      data: {
        simulacao: this.simulacao,
        proposta: copia,
        idFinanciadora: idFinanciadora,
        idTarefa: this.tarefa.id
      },
      panelClass: ['modal-card', 'modal-card-v2']
    });

    dialogRef.afterClosed().subscribe(async (result: any) => {
      if (result) {
        await this.financiadorasComponent.atualizarFinanciadoras();
      }
    });
  }

  excluirProposta(proposta: GiFinPropostaModel) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir a proposta?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then(async (result) => {
      if (result.value) {
        try {
          this.carregandoService.mostra('excluirProposta');
          await this.finSimulacaoService.excluirProposta(proposta.id).toPromise();
          this.notificacaoService.sucesso('Proposta excluída com sucesso!!!');
          await this.financiadorasComponent.atualizarFinanciadoras();
        } catch (erro) {
          this.notificacaoService.erro(erro);
        } finally {
          this.carregandoService.esconde('excluirProposta');
        }
      }
    });
  }

  // buscarFinanciadorasPraExibir() {
  //   if (!this.integrador) {
  //     return this.financiadoras;
  //   } else {
  //     return this.financiadoras.filter(p => p.status === FinSimulacaoFinanciadoraStatus.Aprovada);
  //   }
  // }

  escolherProposta(idProposta: number) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente selecionar essa proposta?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then(async (result) => {
      if (result.value) {
        try {
          this.carregandoService.mostra('selecionarProposta');
          const proposta = await this.finSimulacaoService.selecionarProposta(idProposta).toPromise();

          // if (this.dialogRef !== null && this.dialogRef !== undefined) {
          //   this.dialogRef.close({
          //     escolheuProposta: true,
          //     proposta: proposta
          //   });
          // }

          this.notificacaoService.sucesso('Proposta selecionada com sucesso!!!');
        } catch (erro) {
          // if (this.dialogRef !== null && this.dialogRef !== undefined) {
          //   this.dialogRef.close({
          //     escolheuProposta: false,
          //   });
          // }

          this.notificacaoService.erro(erro);
        } finally {
          this.carregandoService.esconde('selecionarProposta');
        }
      }
    });
  }

  buscarFinanciamentoConfig() {
    this.carregandoService.mostra('buscarFinanciamentoConfig');

    this.financiamentoService.buscar().subscribe(
      (config) => {
        this.configFinanciamento = config.result;
        this.carregandoService.esconde('buscarFinanciamentoConfig');
      },
      (erro) => {
        this.carregandoService.esconde('buscarFinanciamentoConfig');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarSumarioProposta(proposta: GiFinPropostaModel) {
    this.carregandoService.mostra('buscarSumarioProposta');

    this.finSimulacaoService.buscarSumarioPropostaV2(this.tarefa.id, proposta.id).subscribe(
      (dados) => {
        proposta.sumario = dados.result;
        this.carregandoService.esconde('buscarSumarioProposta');
      },
      (erro) => {
        this.carregandoService.esconde('buscarSumarioProposta');
        this.notificacaoService.erro(erro);
      }
    );
  }

  alterarVisibilidadeProposta(proposta: GiFinPropostaModel, visivel: boolean = false) {
    this.carregandoService.mostra('alterarVisibilidadeProposta');

    this.finSimulacaoService.alterarVisibilidadeProposta(this.tarefa.id, proposta.id, visivel).subscribe(
      (resultado) => {
        proposta.visivel = !proposta.visivel;
        this.carregandoService.esconde('alterarVisibilidadeProposta');
      },
      (erro) => {
        this.carregandoService.esconde('alterarVisibilidadeProposta');
        this.notificacaoService.erro(erro);
      }
    );
  }

  podeExibirBotaoEscolhaProposta(proposta: GiFinPropostaModel): boolean {
    if (this.configFinanciamento === null || this.configFinanciamento === undefined) {
      return false;
    }

    //Todo: A Fazer Expiração
    // const propostaExpirada = this.configFinanciamento.validaExpiracaoProposta
    //   ? false
    //   : proposta.simulacaoExpirada;

    return this.origem === FinSimulacaoOrigem.Integrador && this.simulacao.status !== FinSimulacaoStatus.Finalizada;
    // return this.origem === FinSimulacaoOrigem.Integrador && this.simulacao.status !== FinSimulacaoStatus.Finalizada && !propostaExpirada;
  }

  podeEditarExcluirProposta(proposta: GiFinPropostaModel) {
    return (
      this.origem === FinSimulacaoOrigem.Central &&
      this.podeInserirProposta &&
      (this.simulacao.status === FinSimulacaoStatus.Disponivel ||
        this.simulacao.status === FinSimulacaoStatus.Solicitada) &&
      proposta.tipoCriacao == FinPropostaTipoCriacao.Manual
    );
  }

  async atualizarFinanciadoras(commom: CommonFinanceModel = null) {
    if (commom) {
      if (commom.limparDados) {
        this.propostas = [];
      } else {
        this.commom = commom;
        await this.buscarPropostas();
        await this.buscarSumarioFormularioFinanciadora();
      }
    } else {
      await this.financiadorasComponent.atualizarFinanciadoras();
    }
  }

  async buscarSumarioFormularioFinanciadora() {
    this.carregandoService.mostra('buscaSumarioFormularioFinanciadora');

    try {
      this.sumarioFormularioFinanciadora = (
        await this.finSimulacaoService
          .buscarSumarioFormularioFinanciadoraFila(this.tarefa.id, this.commom.idVinculo)
          .toPromise()
      ).result;

      if (
        this.sumarioFormularioFinanciadora.tipoFormulario === TipoFormularioProposta.Manual &&
        this.sumarioFormularioFinanciadora.idFormulario
      ) {
        this.buscarFormularioManual(this.sumarioFormularioFinanciadora.idFormulario);
      } else if (this.sumarioFormularioFinanciadora.tipoFormulario === TipoFormularioProposta.Gateway) {
        this.buscarFormularioGateway();
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscaSumarioFormularioFinanciadora');
    }
  }

  async buscarFormularioManual(idFormulario: number) {
    this.carregandoService.mostra('buscaFormularioManual');

    try {
      const results = (
        await this.finSimulacaoService
          .buscarFormularioManualFila(this.tarefa.id, this.commom.idVinculo, idFormulario)
          .toPromise()
      ).results;

      this.formularioManual = results.map((questao) => {
        const respostaBase: RespostaFormularioModel = {
          idItens: []
        };

        switch (questao.tipo) {
          case TipoCampoPersonalizado.SelecaoUnica:
            questao.resposta = {
              ...respostaBase,
              ...questao.resposta,
              valor:
                questao.resposta != null && questao.resposta.idFormPerguntaItem != null
                  ? questao.resposta.idFormPerguntaItem
                  : null
            };
            break;

          case TipoCampoPersonalizado.SelecaoMultipla:
            questao.resposta = {
              ...respostaBase,
              ...questao.resposta,
              valores: questao.resposta != null && questao.resposta.idItens != null ? questao.resposta.idItens : []
            };
            break;

          case TipoCampoPersonalizado.Texto:
            questao.resposta = {
              ...respostaBase,
              ...questao.resposta,
              texto: questao.resposta != null && questao.resposta.texto != null ? questao.resposta.texto : null
            };
            break;

          default:
            questao.resposta = { ...respostaBase, ...questao.resposta };
        }

        return questao;
      });
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscaFormularioManual');
    }
  }

  async buscarFormularioGateway() {
    this.carregandoService.mostra('buscaFormularioGateway');

    try {
      this.formularioGateway = (
        await this.finSimulacaoService.buscarFormularioGatewayFila(this.tarefa.id, this.commom.idVinculo).toPromise()
      ).result;

      if (this.formularioGateway.schema) {
        const fieldConfig = this.formlyJsonschema.toFieldConfig(JSON.parse(this.formularioGateway.schema), {
          map: (mappedField) => {
            mappedField.templateOptions.disabled = true;

            return mappedField;
          }
        });

        this.formlyFields = [fieldConfig];

        if (this.formularioGateway.model) {
          this.formlyModel = JSON.parse(this.formularioGateway.model);
        }
      }
    } catch (ex) {
      this.notificacaoService.erro(ex);
    } finally {
      this.carregandoService.esconde('buscaFormularioGateway');
    }
  }

  public readonly AnaliseDescontoStatus = AnaliseDescontoStatus;
  public readonly TipoFormularioProposta = TipoFormularioProposta;
  public readonly TipoCampoPersonalizado = TipoCampoPersonalizado;
}
